module.exports = __webpack_public_path__ + "static/media/news3.43e5ee8f.jpg";